import React from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { IMaskInput, useIMask  } from 'react-imask';

import axios_api from '../Api';

import Loader from './common/Loader';

import { API_URL, AUTH_TOKEN, DADATA_API_KEY } from '../Context';

import { AddressSuggestions } from 'react-dadata';
import 'react-dadata/dist/react-dadata.css';


function LabTypeOption(labType) {
  return(
    <option key={labType.guid} value={labType.guid}>{labType.type}</option>
  );
}


function Profile({syncProfile}) {
  const[userProfile, setUserProfile] = useState(Object());
  const[labTypes, setLabTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fieldErrors, setFieldErrors] = useState({})
  const navigate = useNavigate();
  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);
  const dadata_api_key = useContext(DADATA_API_KEY);

  
  React.useEffect(() => {

    let userProfileNext = axios_api.get(api_url + '/profile', {
      headers: {"Authorization": token}
    });
 
    let labTypesNext = axios_api.get(api_url + '/lab_types', {
      headers: {"Authorization": token}
    });

    userProfileNext.then(
      (result) => {
        setLoading(false);
        setUserProfile(result.data);
      },
      (error) => {
        console.log(error)
      }
    );

    labTypesNext.then(
      (result) => {
        setLabTypes(result.data);
      },
      (error) => {
        console.log(error)
      }
    );

  }, []);

  let lab_type_options = [];
  for (let i in labTypes) {
    lab_type_options.push(LabTypeOption(labTypes[i])); 
  }

  let law_basis_options = [
    {key: 'Устава', value: 'Устава'}, 
    {key: 'Приказа', value: 'Приказа'}, 
    {key: 'Доверенности', value: 'Доверенности'}
  ];


  const handleChange = (event) => {
    console.log(event)
    let name = event.target.id;
    let value = event.target.value;
    let userProfileNext = structuredClone(userProfile);
    userProfileNext[name] = value;
    setUserProfile(userProfileNext);
  };


  const handleSelectSuggestedDeliveryAddress = (event) => {
    //console.log(event)
    let address = ''
    if (event.data.postal_code != null) {
      address = event.data.postal_code + ', ' + event.value;
    } else {
      address = event.value;
    }
    
    let userProfileNext = structuredClone(userProfile);
    userProfileNext['delivery_address'] = address;
    setUserProfile(userProfileNext);
  };


  const handleSelectSuggestedLegalAddress = (event) => {
    //console.log(event)
    let address = ''
    if (event.data.postal_code != null) {
      address = event.data.postal_code + ', ' + event.value;
    } else {
      address = event.value;
    }
    
    let userProfileNext = structuredClone(userProfile);
    userProfileNext['legal_address'] = address;
    setUserProfile(userProfileNext);
  };


  const validatePhones = () => {

    console.log(userProfile)

    let fieldErrorsNext = {}
    let phonesFieldNames = [
      'organization_phone', 
      'organization_mobile_phone', 
      'secretary_phone', 
      'accounting_phone'
    ]

    for (let i in phonesFieldNames) {
      console.log(i)
      let filedName = phonesFieldNames[i]
      console.log(userProfile[filedName].length)
      if (userProfile[filedName].length === 0 || userProfile[filedName].length === 18) {
        console.log(filedName + ': valid')
      } else {
        console.log(filedName + ': invalid')
        fieldErrorsNext[filedName] = 'телефон должен содержать 10 символов'
      }
    }

    console.log(fieldErrorsNext)
    if ( Object.keys(fieldErrorsNext).length === 0 ) {
      return true
    } else {
      setFieldErrors(fieldErrorsNext)
      return false
    }

  }

  // СДЕСЬ МЫ ОТПРАВЛЯЕМ ДАННЫЕ userProfile ИЗ STATE (который раньше был изменен через onChange), А НЕ ИЗ ФОРМЫ. Наверное это неправильно?   
  const handleSubmit = async e => {
    e.preventDefault();

    if (validatePhones()) {
      syncProfile(userProfile);
      navigate("/");
    } else {
      window.scrollTo(0, 0)
      //window.scrollTo(0, document.body.scrollHeight);
      console.log('')
    }

  }

  //const inputRef = useIMask({
  //   mask: '+7 (___) ___-__-__',
  //  replacement: { _: /\d/ },
  //});

  let ref = useRef(0);
  //let inputRef = useRef(0); 

  return loading ? 
  (
    <Loader/>
  ) : (
    <>
      <div className="row">
        <h3 className="m-3">Профиль пользователя</h3>
        <h6 className="ms-3 mb-4"> {userProfile.organization}</h6>
      </div>
      <div className="col-10 ms-3 mb-5 lk-form">
        <form onSubmit={handleSubmit}>
          {Object.keys(fieldErrors).length > 0 &&
            <p className='text-danger mb-3'>пожалуйста, исправьте ошибки ниже</p>
          }
          <div className="input-group my-3">
            <label className="col-4">
              <p>Руководитель <span className="fw-light">(должность, ФИО)</span></p>
              <input id="director" type="text" className="form-control" value={userProfile.director} onChange={handleChange}/>
            </label>
            <label className="ms-5 col-4">
              <p>Действует на основании</p>
              {userProfile.law_basis ? 
                <select id="law_basis" className="lk-select form-select" value={userProfile.law_basis} onChange={handleChange}>
                  <option select disabled value=""> - выберите вариант - </option>
                  <option value="Устава">Устава</option>
                  <option value="Приказа">Приказа</option>
                  <option value="Доверенности">Доверенности</option>
                </select> : 
                <select id="law_basis" className="lk-select form-select" value="" onChange={handleChange}>
                  <option select disabled value=""> - выберите вариант - </option>
                  <option value="Устава">Устава</option>
                  <option value="Приказа">Приказа</option>
                  <option value="Доверенности">Доверенности</option>
                </select>
              }
              {/*<input id="law_basis" type="text" className="form-control" value={userProfile.law_basis} onChange={handleChange}/>*/}
            </label>
          </div>  

          <div className="input-group my-3">
            <label className="mt-3">
              <p>Тип лаборатории</p>
              {userProfile.lab_type ? 
                <select id="lab_type" className="lk-select form-select" value={userProfile.lab_type} onChange={handleChange}>
                  <option select disabled value=""> - выберите вариант - </option>
                  {lab_type_options}
                </select> 
              :
                <select id="lab_type" className="lk-select form-select" value="" onChange={handleChange}>
                  <option select disabled value=""> - выберите вариант - </option>
                  {lab_type_options}
                </select> 
              }
            </label>
          </div>

          <div className="input-group my-3">  
            <label className="mt-3 col-4">
              <p>Заведующий лабораторией</p>
              <input id="lab_chief" type="text" className="form-control" value={userProfile.lab_chief} onChange={handleChange}/>
            </label>
          </div>
          
          {/*<div className="input-group my-3">
            <label className="mt-3">
              <p>Контактный телефон</p>
              <input id="organization_phone" type="text"  pattern="[0-9.\s\+\(\)\-]+" className="form-control" value={userProfile.organization_phone} onChange={handleChange}/>
            </label>
          </div>*/}

          <div className="input-group my-3">
            <label className="mt-3">
              <p>Контактный телефон</p>
              <IMaskInput
                mask="+{7} (000) 000-00-00"
                radix="."
                value={userProfile.organization_phone}
                unmask={false} // true|false|'typed'
                // ref & inputRef - функциональность сейчас не используется.
                ref={ref}
                //inputRef={inputRef}  // access to nested input
                // DO NOT USE onChange TO HANDLE CHANGES!
                // USE onAccept INSTEAD
                onAccept={
                  // depending on prop above first argument is
                  // `value` if `unmask=false`,
                  // `unmaskedValue` if `unmask=true`,
                  // `typedValue` if `unmask='typed'`
                  (value, mask) => {
                    // console.log(value)
                    handleChange({target: {id: "organization_phone", value: value}})
                  }
                }
                // ...and more mask props in a guide

                // input props also available
                id="organization_phone"
                className="form-control"
                placeholder='+7(___) ___-__-__'
              />
              <p className='text-danger mt-1'>{fieldErrors['organization_phone']}</p>
            </label>
          </div>

          <div className="input-group my-3">  
            <label className="mt-3 me-4">
              <p>Мобильный телефон заведующего <span className="fw-light"> (используется для смс и курьера)</span></p>
              <IMaskInput
                mask="+{7} (000) 000-00-00"
                radix="."
                value={userProfile.organization_mobile_phone}
                unmask={false}
                onAccept={
                   (value, mask) => {
                    handleChange({target: {id: "organization_mobile_phone", value: value}})
                  }
                }
                id="organization_mobile_phone"
                className="form-control"
                placeholder='+7(___) ___-__-__'
              />
            <p className='text-danger mt-1'>{fieldErrors['organization_mobile_phone']}</p>  
            </label>
            <label className="mt-3 ms-5 ps-2">
              <p>Электронная почта заведующего</p>
              <div className="input-group mb-3">
                <span className="input-group-text">@</span>
                <input id="organization_email" type="email" className="form-control" value={userProfile.organization_email} onChange={handleChange}/>
              </div>
           </label>
          </div>



          <div className="input-group my-3">

            {/* 
            <label className="mt-3 col-4">
              <p>Адрес доставки контрольных образцов</p>
              <input id="delivery_address" type="text" className="form-control" value={userProfile.delivery_address} onChange={handleChange}/>
            </label>
            */}

            <label className="mt-3 col-4">
              <p>Адрес доставки контрольных образцов</p>
                <AddressSuggestions 
                  token={dadata_api_key} 
                  value={{value: userProfile.delivery_address}} // <- задаем initial value. Здесь обязательно должен передаваться объект с полем 'value'
                  onChange={handleSelectSuggestedDeliveryAddress} // <- срабатывает при выборе адреса из подсказок
                  minChars={1} 
                  delay={100}
                  inputProps={{
                      id: "delivery_address",
                      type: "text", 
                      className: "form-control",
                      onChange: handleChange // <- срабатывает при самостоятельном вводе пользователя 
                  }}
                />
            </label>
            
            <label className="mt-3 ms-5 col-4">
              <p>Получатель</p>
              <input id="recipient" type="text" className="form-control" value={userProfile.recipient} onChange={handleChange}/>
            </label>
          </div>
         
          <div className="input-group my-3">
            <label className="mt-3">
              <p>Аттестат аккредитации <span className="fw-light">(при наличии)</span></p>
              <input id="certificate" type="text" className="form-control" value={userProfile.certificate} onChange={handleChange}/>
            </label>                                
          </div>


          <div className="input-group my-3 me-5">
            <label className="mt-3">
              <p>Телефон руководителя или секретаря</p>
              <IMaskInput
                mask="+{7} (000) 000-00-00"
                radix="."
                value={userProfile.secretary_phone}
                unmask={false}
                onAccept={
                   (value, mask) => {
                    handleChange({target: {id: "secretary_phone", value: value}})
                  }
                }
                id="secretary_phone"
                className="form-control"
                placeholder='+7(___) ___-__-__'
              />
              <p className='text-danger mt-1'>{fieldErrors['secretary_phone']}</p>  
            </label>
            <label className="mt-3 ms-5">
              <p>Электронная почта руководителя или секретаря</p>
              <div className="input-group mb-3">
                <span className="input-group-text">@</span>
                <input id="secretary_email" type="email" className="form-control" value={userProfile.secretary_email} onChange={handleChange}/>
              </div>
            </label>
          </div>

          <div className="input-group my-3">
            <label className="mt-3"  style={{width: "298px"}}>
              <p>Телефон бухгалтера</p>
              <IMaskInput
                mask="+{7} (000) 000-00-00"
                radix="."
                value={userProfile.accounting_phone}
                unmask={false}
                onAccept={
                   (value, mask) => {
                    handleChange({target: {id: "accounting_phone", value: value}})
                  }
                }
                id="accounting_phone"
                className="form-control"
                placeholder='+7(___) ___-__-__'
              />
              <p className='text-danger mt-1'>{fieldErrors['accounting_phone']}</p>
            </label>
            <label className="mt-3 ms-5" style={{width: "379px"}}> 
              <p>Электронная почта бухгалтера</p>
              <div className="input-group mb-3">
                <span className="input-group-text">@</span>
                <input id="accounting_email" type="email" className="form-control" value={userProfile.accounting_email} onChange={handleChange}/>
              </div>  
            </label>         
          </div>

          <div className="input-group my-3">
            <label className="mt-3">
              <p>Кодовое слово</p>
              <input id="code_word" type="text" required minLength="4" maxLength="7" className="form-control" value={userProfile.code_word} onChange={handleChange}/>
            </label>
          </div>

          <label className="mt-3 col-5">
            <p>Юридический адрес</p>
              <AddressSuggestions 
                token={dadata_api_key} 
                value={{value: userProfile.legal_address}} // <- задаем initial value. Здесь обязательно должен передаваться объект с полем 'value'
                onChange={handleSelectSuggestedLegalAddress} // <- срабатывает при выборе адреса из подсказок
                minChars={1} 
                delay={100}
                inputProps={{
                    id: "legal_address",
                    type: "text", 
                    className: "form-control",
                    onChange: handleChange // <- срабатывает при самостоятельном вводе пользователя 
                }}
              />
          </label>

          <div className="input-group my-3">  
            <label className="mt-3 me-3">
              <p>ИНН</p>
              <input id="inn" type="text" className="form-control" value={userProfile.inn} onChange={handleChange} disabled/>
            </label>    
            <label className="mt-3 ms-4 ps-1">
              <p>КПП</p>
              <input id="kpp" type="text" className="form-control" value={userProfile.kpp} onChange={handleChange}/>
            </label>  
          </div>

          <div className="my-3 mt-5">
            {/*{Object.keys(fieldErrors).length > 0 &&
              <p className='text-danger mb-3'>пожалуйста, исправьте ошибки выше</p>
            }*/}
            <button className="lk-button" type="submit">Сохранить</button>
          </div>
        </form>
      </div>
    </>
  );
}

export default Profile;